import { Storage } from '@intelipost-js/secure-providers';

const PageWindows = () => import('./PageWindows'); // eslint-disable-line
const PageManageWindow = () => import('./pages/manage/PageManageWindow'); // eslint-disable-line
const originMenu = Storage.get('originMenu', 'local') || 'oldmenu';
const pageTitle = originMenu === 'newmenu' ? 'Gestão de Capacidade' : 'Janela de disponibilidade';

export default {
  path: 'window',
  children: [
    {
      path: '',
      name: 'window',
      component: PageWindows,
      meta: {
        title: pageTitle,
      },
    },
    {
      name: 'window-manage',
      path: 'manage/:id?',
      component: PageManageWindow,
      params: {
        id: null,
      },
      meta: {
        title: 'Gerenciar janelas',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-capacity-management/features/window/routes.js